import { ITinymedicPatientOrder } from 'app/shared/model/tinymedic-patient-order.model';

export interface ITinymedicPatientOrderFile {
  id?: string;
  name?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  tinymedicPatientOrder?: ITinymedicPatientOrder | null;
}

export const defaultValue: Readonly<ITinymedicPatientOrderFile> = {
  active: false,
};
